import styled from 'styled-components'

export const StyledCalendarPickerWeekday = styled.td`
    text-align: center;
    text-transform: uppercase;
`
